module.exports = __webpack_public_path__ + "braeuer.aa808c513547286e69cdfad598ac913b.png";